import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MapSelectPositionModalPage } from './map-select-position-modal.page';

const routes: Routes = [
  {
    path: '',
    component: MapSelectPositionModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapSelectPositionModalPageRoutingModule {}
